export default __webpack_public_path__ + "static/media/login-bg-4.01f5e956.jpg";